import { User } from './user'
import { Reply } from './reply'
import { BaseModel, BelongsTo, HasMany, Attribute } from './base-model'

export class Event extends BaseModel {
  public static KINDS = {
    // listening: '聞こう',
    // resting: 'ひとやすみ',
    important: '重要',
    // search: '調べよう',
    // not_understand: 'わからない',
    // writing: '書き写す',
    interesting: 'なるほど',
    difficult: 'むずかしい',
    comment: '疑問',
    caption: '注釈',
    title: '区切り'
  }
  public static ICONS = {
    listening: 'volume-up',
    resting: 'coffee',
    important: 'exclamation',
    search: 'search',
    not_understand: 'question',
    writing: 'pencil',
    interesting: 'lightbulb-o',
    difficult: 'question',
    comment: 'comment',
    caption: 'cc',
    title: 'bicycle'
  }
  public static COLORS = {
    listening:      'rgba(251, 171, 98, 0.9)',
    resting:        'rgba(186, 225, 65, 0.9)',
    important:      'rgba(239, 67, 116, 0.9)',
    search:         'rgba(104, 209, 236, 0.9)',
    not_understand: 'rgba(175, 67, 147, 0.9)',
    writing:        'rgba(48, 48, 136, 0.9)',
    interesting:     'rgba(251, 171, 98, 0.9)',
    difficult: 'rgba(175, 67, 147, 0.9)',
    comment:        'rgba(13, 97, 8, 0.9)',
    caption:        'rgba(48, 48, 136, 0.9)',
    title:          'rgba(136, 48, 48, 0.9)'
  }

  public id       : number
  public kind     : string
  @Attribute(Date)   public createdAt: Date
  public position : number
  public content  : string
  @BelongsTo(User)   public user     : User
  public sessionId: string
  @HasMany(Reply) public replies: Reply[]

  public relPos(total: number): number {
    return this.position / total
  }

  public get kindTxt(): string {
    return Event.KINDS[this.kind]
  }

  public get iconType(): string {
    return Event.ICONS[this.kind]
  }

  public get jumpOffset(): number {
    switch(this.kind) {
      case 'listening':
      case 'important':
      case 'not_understand':
        // 10秒前
        return -10
      case 'writing':
      case 'search':
        // 5秒前
        return -5
      case 'resting':
        // 20秒後
        return 20
      default:
        return 0
    }
  }

  public get positionWithOffset(): number {
    return this.position + this.jumpOffset
  }
}



// WEBPACK FOOTER //
// ./src/models/event.ts